import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../Theme';

import { SizeType } from '../_size';

/**
 * Import Themes
 */

import iconBlogTheme from './_blog';
import iconSiteTheme from './_site';

/**
 * Group Themes
 */

const iconThemes = (size: SizeType, bg: boolean) =>
  new MatchedMap([
    [ThemeEnum.Blog, iconBlogTheme(size)],
    [ThemeEnum.Site, iconSiteTheme(size, bg)],
  ]);

/**
 * Theme Hook
 */

const useIconTheme = (size: SizeType, bg: boolean) => useTheme({}, iconThemes(size, bg));

export default useIconTheme;
